/** Keys used for client-side auth session (keep in sync across stores and axios). */
export const AUTH_STORAGE_KEYS = [
  "tvet_mis",
  "name",
  "role",
  "auth_token",
];

/**
 * Remove all auth-related entries from localStorage.
 */
export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(`Failed to remove localStorage key "${key}":`, e);
    }
  });
}

/**
 * Read bearer token from persisted session.
 */
export function getStoredAuthToken() {
  const direct = localStorage.getItem("auth_token");
  if (direct) return direct;

  const raw = localStorage.getItem("tvet_mis");
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return parsed?.token || parsed?.userData?.token || null;
  } catch {
    return null;
  }
}
